var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-tag"},[_c('span',{staticClass:"rating-tag__label"},[_vm._v("\n    "+_vm._s(_vm.rating.toFixed(1))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }